import { Animal } from '../../interfaces';

export const isRemovedOrHasPreviousGroup = (animalSelected: Animal | undefined) => {
  return animalSelected !== undefined && (animalSelected.removed === true || animalSelected.previousGroup !== undefined);
};
